/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Article } from '../../models/article';
import { ArticleApiRespModel } from '../../models/article-api-resp-model';

export interface ApiMasterArticleAddPost$Params {
      body?: Article
}

export function apiMasterArticleAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterArticleAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterArticleAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleApiRespModel>;
    })
  );
}

apiMasterArticleAddPost.PATH = '/api/Master/Article/Add';
